/**
 * El reparto por motivo de los clientes sin día, en una línea para el encabezado
 * del bloque colapsado.
 *
 * Existe porque ese bloque es **accionable** —es el origen del arrastre a un día—
 * y colapsarlo sin decir qué hay adentro convertiría trabajo pendiente en trabajo
 * invisible. Es la misma decisión que ya tomó el diálogo de `loads`, cuyo comentario
 * la resume: *"El porqué se lee sin desplegar; el detalle sigue adentro."*
 */

/** Un grupo de no planificadas: su etiqueta de motivo y sus clientes. */
export interface LabeledGroup {
  label: string;
  items: unknown[];
}

const SEPARATOR = ' · ';

/**
 * @returns Algo como `12 Sin capacidad disponible · 8 Fuera de alcance`, de mayor a
 *   menor cantidad. Cadena vacía si no hay nada que resumir.
 */
export function unplannedSummary(groups: LabeledGroup[] | undefined): string {
  return (groups ?? [])
    .filter((g) => g.items.length > 0)
    // El encabezado es una sola línea: el motivo que más clientes explica es el que
    // decide si vale la pena desplegar, así que va primero.
    .sort((a, b) => b.items.length - a.items.length)
    .map((g) => `${g.items.length} ${g.label}`)
    .join(SEPARATOR);
}
